<script>
export default {
  name: 'SharedData',
  props: {
    componentData: {
      type: Object,
      required: true,
    },
  },
}
</script>

<template>
  <div :class="$style.container"/>
</template>

<style scoped lang="scss" module>
.container {
  width: 0 !important;
  height: 0 !important;
  padding: 0 !important;
  margin: 0 !important;
  background-color: transparent !important;
}
</style>
